import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AuthLayoutContainer from "./AuthLayoutContainer";
import OrgMemberRegistrationComponent from "./components/OrgMemberRegistrationComponent";
import UserRegistrationComponent from "./components/UserRegistrationComponent";
import EventRegistrationComponent from "./components/EventRegistrationComponent";
import GoogleRecaptchaWrapper from "../../sharedComponents/GoogleReCaptchaWrapper";

const useStyles = makeStyles((theme) => ({

}));

const EventRegistration = (props) => {
    const classes = useStyles();
    const params = new URLSearchParams(props.location.search);
    const token = params.get("token");

    useEffect(() => {
    }, [])

    return <>
        <AuthLayoutContainer children={<GoogleRecaptchaWrapper><EventRegistrationComponent /></GoogleRecaptchaWrapper>} />
    </>

}

export default EventRegistration;